import React from 'react';

import { Link } from 'react-router-dom';
import LogoImage from '../../lib/images/logo.png';
import * as RT from '../../constants/Routing';
export default class Component extends React.Component {


  displaySearchModal = () => {
    document.querySelector('.searchWrap').classList.toggle('slideIn')
    document.body.classList.toggle('overflow-hidden')
    document.documentElement.classList.toggle('overflow-hidden')
    const toggleBtn = document.querySelector('.searchToggleBtn')
    toggleBtn.classList.toggle('active')
    if (toggleBtn.innerText === 'search') {
      toggleBtn.innerText = 'close'
    } else {
      toggleBtn.innerText = 'search'
    }
  }

  render = () => {

    let alertIcon
    if (this.props.unReadNotification) {
      alertIcon = (
        <i className="unreadNotice material-icons">fiber_manual_record</i>
      )
    }


    return (
      <header id='appHeader' className='panel'>

        <i className="material-icons searchToggleBtn" onClick={this.displaySearchModal}>search</i>
        <Link to={RT.ROOT_PATH} className='navbar-brand'><img src={LogoImage} alt="circrew" className="logo-img" /></Link>
        <span className="toggle-button">
          {alertIcon}
          <i className="material-icons toggle-button">dehaze</i>
        </span>
        
        <span style={{ display: 'none' }} className='side-menu-close-btn'></span>
        
        
      </header>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx